import { useCallback, useEffect } from "react";

export function useUnhandledRejectionHandler(
  callbackFn: (event: PromiseRejectionEvent) => void
): void {
  const unhandledPromiseRejectionHandler = useCallback(
    (event: PromiseRejectionEvent) => {
      callbackFn(event);
    },
    [callbackFn]
  );

  useEffect(() => {
    window.addEventListener(
      "unhandledrejection",
      unhandledPromiseRejectionHandler
    );

    return () => {
      window.removeEventListener(
        "unhandledrejection",
        unhandledPromiseRejectionHandler
      );
    };
  }, [unhandledPromiseRejectionHandler]);
}
